"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bsc = void 0;
exports.bsc = {
    "addresses": {
        "ProxyAdmin": "0x3C752d0D78BbFddA6BF4b6000a01228B732441aE",
        "Multicall2": "0xcA11bde05977b3631167028862bE2a173976CA11",
        "Sumer": "0x553d713e0fB958932b6C40ABAf0b5A1fFae73Da2",
        "CompoundLens": "0xC6C338eC3b4aa5e5237b9B8427741a582f96568D",
        "FeedPriceOracle": "0x77CcA710E21A94B94a26A98eA23027D64e36B9d4",
        "CompLogic": "0xe3502f1c2450Ed1Bb87B87a84AF6742F60f41368",
        "RedemptionManager": "0xE27496Ec5d6E19521d636e78c127fF2Cf59ee914",
        "Timelock": "0x549D0CdC753601fbE29f9DE186868429a8558E07",
        "Comptroller": "0x15B5220024c3242F7D61177D6ff715cfac4909eD",
        "sdrBNB": "0x23811C17BAc40500deCD5FB92d4FEb972aE1E607",
        "BNB": "0x0000000000000000000000000000000000000000",
        "CErc20": "0x43CEcd98CD9C7463E7F212FB218f73fa1ecaa420",
        "suErc20": "0x608BE61c585fEd52Abe5329d52DA7bD818008292",
        "JumpRate#StableBC": "0x4450f5Fd0fFDfa3D11d8149CC62a03b1Ab4EEBc8",
        "JumpRate#BTCBC_AltStables": "0x3CfC6b4E9a8f030F6894d35618A8315af3E30DB9",
        "JumpRate#Others": "0x248C217666421ae7BE28bEf83E05aa4bf33dbdcb",
        "JumpRate#ETH": "0x42778d0962884510b85d4D1B30DFe9e9Dd270446",
        "ZeroRate": "0x56048C88309CAF13A942d688bfB9654432910d6e",
        "sdrUSDC": "0xBc6590A7b15513e4D649b158393175a839F27ED8",
        "USDC": "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
        "sdrUSDT": "0xE550a6f792a8B6C07555378EA74063021885A33e",
        "USDT": "0x55d398326f99059ff775485246999027b3197955",
        "sdrBTCB": "0xf7BB299dc8e627eaEc4282FFc236E085aef8FAF3",
        "BTCB": "0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c",
        "sdrSolvBTC": "0x86208Af42580823401B504B341150c92CC99C69A",
        "SolvBTC": "0x4aae823a6a0b376de6a78e74ecc5b079d38cbcf7",
        "sdrxSolvBTC": "0xdCA98947c3c9cf0B3CF448b6A03f991598Fb9460",
        "xSolvBTC": "0x1346b618dc92810ec74163e4c27004c921d446a5",
        "sdrSolvBTC.ENA": "0x218C9349E8522466bD57FB878a1a479AeAEF02a4",
        "SolvBTC.ENA": "0x53e63a31fd1077f949204b94f431bcab98f72bce",
        "sdrPumpBTC": "0x35C840655D3a2E77d79f179C34e547726B963314",
        "PumpBTC": "0xf9C4FF105803A77eCB5DAE300871Ad76c2794fa4",
        "sdrETH": "0x2509bd3B69440D39238b464d09f9F04A61fd62C6",
        "ETH": "0x2170ed0880ac9a755fd29b2688956bd959f933f8"
    },
    "tokenPairs": [
        {
            "ctokenSym": "sdrUSDC",
            "ctokenAddr": "0xBc6590A7b15513e4D649b158393175a839F27ED8",
            "underlySym": "USDC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrUSDT",
            "ctokenAddr": "0xE550a6f792a8B6C07555378EA74063021885A33e",
            "underlySym": "USDT",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x55d398326f99059ff775485246999027b3197955",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrBTCB",
            "ctokenAddr": "0xf7BB299dc8e627eaEc4282FFc236E085aef8FAF3",
            "underlySym": "BTCB",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrSolvBTC",
            "ctokenAddr": "0x86208Af42580823401B504B341150c92CC99C69A",
            "underlySym": "SolvBTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x4aae823a6a0b376de6a78e74ecc5b079d38cbcf7",
            "assetGroupId": 5
        },
        {
            "ctokenSym": "sdrxSolvBTC",
            "ctokenAddr": "0xdCA98947c3c9cf0B3CF448b6A03f991598Fb9460",
            "underlySym": "xSolvBTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x1346b618dc92810ec74163e4c27004c921d446a5",
            "assetGroupId": 5
        },
        {
            "ctokenSym": "sdrSolvBTC.ENA",
            "ctokenAddr": "0x218C9349E8522466bD57FB878a1a479AeAEF02a4",
            "underlySym": "SolvBTC.ENA",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x53e63a31fd1077f949204b94f431bcab98f72bce",
            "assetGroupId": 5
        },
        {
            "ctokenSym": "sdrPumpBTC",
            "ctokenAddr": "0x35C840655D3a2E77d79f179C34e547726B963314",
            "underlySym": "PumpBTC",
            "ctokenDecimal": 8,
            "underlyDecimal": 8,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xf9C4FF105803A77eCB5DAE300871Ad76c2794fa4",
            "assetGroupId": 5
        },
        {
            "ctokenSym": "sdrETH",
            "ctokenAddr": "0x2509bd3B69440D39238b464d09f9F04A61fd62C6",
            "underlySym": "ETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x2170ed0880ac9a755fd29b2688956bd959f933f8",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrBNB",
            "ctokenAddr": "0x23811C17BAc40500deCD5FB92d4FEb972aE1E607",
            "underlySym": "BNB",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": true,
            "permitEnabled": false,
            "underlyAddr": "0x0000000000000000000000000000000000000000"
        }
    ],
    "rateModels": [
        {
            "name": "JumpRate#Others",
            "contract": "JumpRateModelV2",
            "address": "0x248C217666421ae7BE28bEf83E05aa4bf33dbdcb",
            "tokens": [
                "BNB",
                "SolvBTC",
                "SolvBTC.BBN",
                "SolvBTC.ENA",
                "PumpBTC",
                "BNB"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.1556",
            "jumpMultiplierPerYear": "5.582",
            "kink": "0.45"
        },
        {
            "name": "JumpRate#StableBC",
            "contract": "JumpRateModelV2",
            "address": "0x4450f5Fd0fFDfa3D11d8149CC62a03b1Ab4EEBc8",
            "tokens": [
                "USDC",
                "USDT"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.0933",
            "jumpMultiplierPerYear": "3.2",
            "kink": "0.75"
        },
        {
            "name": "JumpRate#BTCBC_AltStables",
            "contract": "JumpRateModelV2",
            "address": "0x3CfC6b4E9a8f030F6894d35618A8315af3E30DB9",
            "tokens": [
                "BTCB"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.0889",
            "jumpMultiplierPerYear": "5.5273",
            "kink": "0.45"
        },
        {
            "name": "JumpRate#ETH",
            "contract": "JumpRateModelV2",
            "address": "0x42778d0962884510b85d4D1B30DFe9e9Dd270446",
            "tokens": [
                "ETH"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.036",
            "jumpMultiplierPerYear": "3.2",
            "kink": "0.75"
        }
    ],
    "blocksPerYear": 31536000
};
//# sourceMappingURL=bsc.js.map